import { useState } from 'react'
import { supabase } from "@/integrations/supabase/client"
import { useToast } from "@/components/ui/use-toast"

export interface UploadedFile {
  name: string;
  url: string;
}

export const useFileUpload = () => {
  const { toast } = useToast()
  const [uploading, setUploading] = useState(false)
  const [uploadedFiles, setUploadedFiles] = useState<UploadedFile[]>([])

  const handleFileUpload = async (file: File) => {
    if (!file) return

    setUploading(true)
    const formData = new FormData()
    formData.append('file', file)

    try {
      const { data, error } = await supabase.functions.invoke('upload-reference', {
        body: formData,
      })

      if (error) throw error

      const newFile = {
        name: data.filename,
        url: data.url
      }

      setUploadedFiles(prev => [...prev, newFile])

      toast({
        title: "File uploaded successfully",
        description: `${file.name} has been uploaded.`,
      })

      return newFile
    } catch (error) {
      console.error('Upload error:', error)
      toast({
        title: "Upload failed",
        description: "There was an error uploading your file.",
        variant: "destructive",
      })
      return null
    } finally {
      setUploading(false)
    }
  }

  const removeFile = (fileToRemove: UploadedFile) => {
    setUploadedFiles(prev => prev.filter(file => file.name !== fileToRemove.name))
  }

  return {
    uploading,
    uploadedFiles,
    handleFileUpload,
    removeFile,
    setUploadedFiles
  }
}